import { render, staticRenderFns } from "./BookingTypeCard.vue?vue&type=template&id=59c9cc74&scoped=true&"
import script from "./BookingTypeCard.vue?vue&type=script&lang=ts&"
export * from "./BookingTypeCard.vue?vue&type=script&lang=ts&"
import style0 from "./BookingTypeCard.vue?vue&type=style&index=0&id=59c9cc74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c9cc74",
  null
  
)

export default component.exports